var map = {
	"./assignments/area-rectangle-1.svg": 77,
	"./assignments/area-rectangle-2.svg": 78,
	"./assignments/assignment-12-angle.svg": 79,
	"./assignments/assignment-29/MDFplader.svg": 80,
	"./assignments/assignment-29/OSBplader.svg": 81,
	"./assignments/assignment-29/fuldtoemmer.svg": 82,
	"./assignments/assignment-29/gipsskruer.svg": 83,
	"./assignments/assignment-29/gude-2022-08-22.log": 84,
	"./assignments/assignment-29/gude-2022-08-23.log": 85,
	"./assignments/assignment-29/halvtoemmer.svg": 86,
	"./assignments/assignment-29/isoleringsmaatter.svg": 87,
	"./assignments/assignment-29/krydsfinerplader.svg": 88,
	"./assignments/assignment-29/spaapladeskruer.svg": 89,
	"./assignments/assignment-29/staalreklar.svg": 90,
	"./assignments/assignment-41/option-1.svg": 91,
	"./assignments/assignment-41/option-2.svg": 92,
	"./assignments/assignment-41/option-3.svg": 93,
	"./assignments/assignment-41/option-4.svg": 94,
	"./assignments/assignment-41/option-5.svg": 95,
	"./assignments/assignment-41/option-6.svg": 96,
	"./assignments/assignment-41/option-7.svg": 97,
	"./assignments/assignment-41/option-8.svg": 98,
	"./assignments/assignment-41/option-9.svg": 99,
	"./assignments/assignment-list.svg": 100,
	"./assignments/badebro.svg": 101,
	"./assignments/beklædningsbrædder.svg": 102,
	"./assignments/bindingsvaerk.svg": 103,
	"./assignments/bro.svg": 104,
	"./assignments/butiksindretning.svg": 105,
	"./assignments/bænkhammer.svg": 106,
	"./assignments/bænkvinkel.svg": 107,
	"./assignments/cirkel.svg": 108,
	"./assignments/countersunk-screws.svg": 109,
	"./assignments/cushion-box2.svg": 110,
	"./assignments/education-map.svg": 111,
	"./assignments/educations-girls.svg": 112,
	"./assignments/educations-highschools-applicants.svg": 113,
	"./assignments/educations.svg": 114,
	"./assignments/efterisolering.svg": 115,
	"./assignments/elipse.svg": 116,
	"./assignments/energysticker.svg": 117,
	"./assignments/fnugrulle.svg": 118,
	"./assignments/fugemasse.svg": 119,
	"./assignments/fuksvans.svg": 120,
	"./assignments/furniture/couples-bench.png": 121,
	"./assignments/furniture/garden-bench.png": 122,
	"./assignments/furniture/leopold-chair.png": 123,
	"./assignments/furniture/new-hospital.png": 124,
	"./assignments/furniture/stair-furniture.png": 125,
	"./assignments/furniture/table-bench-covered.png": 126,
	"./assignments/furniture/table-bench-set.png": 127,
	"./assignments/geometry/box-geometry.svg": 128,
	"./assignments/geometry/calculate-circumference-55.svg": 129,
	"./assignments/geometry/circle-area.svg": 130,
	"./assignments/geometry/circle-circumference.svg": 131,
	"./assignments/geometry/cushion-box.svg": 132,
	"./assignments/geometry/cylinder-geometry.svg": 133,
	"./assignments/geometry/cylinder.svg": 134,
	"./assignments/geometry/former.svg": 135,
	"./assignments/geometry/geometry.svg": 136,
	"./assignments/geometry/halfcircle-circumference.svg": 137,
	"./assignments/geometry/hexagon.svg": 138,
	"./assignments/geometry/lidless-box.svg": 139,
	"./assignments/geometry/polygon-circumference.svg": 140,
	"./assignments/geometry/polygon-circumference2.svg": 141,
	"./assignments/geometry/quartercircle-circumference.svg": 142,
	"./assignments/geometry/rectangle-area.svg": 143,
	"./assignments/geometry/square-circumference.svg": 144,
	"./assignments/geometry/squares.svg": 145,
	"./assignments/geometry/triangle-angle.svg": 146,
	"./assignments/geometry/triangle-area.svg": 147,
	"./assignments/geometry/triangle-area2.svg": 148,
	"./assignments/geometry/triangle-circumference.svg": 149,
	"./assignments/geometry/triangle-letters.svg": 150,
	"./assignments/gevindstænger.svg": 151,
	"./assignments/gipsvaegge.svg": 152,
	"./assignments/gulv.svg": 153,
	"./assignments/hegn-stolpe.svg": 154,
	"./assignments/hegn.svg": 155,
	"./assignments/hængsel.svg": 156,
	"./assignments/icon-check-mark-assignment.svg": 157,
	"./assignments/icon-error-check-mark-assignment.svg": 158,
	"./assignments/kløfthammer.svg": 159,
	"./assignments/koben.svg": 160,
	"./assignments/koordinatsystem.svg": 161,
	"./assignments/kridtsnor.svg": 162,
	"./assignments/kvadrat.svg": 163,
	"./assignments/ligesidet-trekant.svg": 164,
	"./assignments/lister.svg": 165,
	"./assignments/lægtehammer.svg": 166,
	"./assignments/material-pyramid.pdf": 56,
	"./assignments/materials/3-layer-glass.svg": 167,
	"./assignments/materials/aerated-concrete.svg": 168,
	"./assignments/materials/concrete.svg": 169,
	"./assignments/materials/construction-steel.svg": 170,
	"./assignments/materials/construction-wood.svg": 171,
	"./assignments/materials/copper-plate.svg": 172,
	"./assignments/materials/fiber-cement-boards.svg": 173,
	"./assignments/materials/fiber-plaster.svg": 174,
	"./assignments/materials/glass-wool.svg": 175,
	"./assignments/materials/linoleum.svg": 176,
	"./assignments/materials/paper-wool.svg": 177,
	"./assignments/materials/reused-bricks.svg": 178,
	"./assignments/materials/rockwool.svg": 179,
	"./assignments/materials/roof-reeds.svg": 180,
	"./assignments/materials/roof-tiles.svg": 181,
	"./assignments/materials/roofing-felt.svg": 182,
	"./assignments/materials/wood-fiber-insulation.svg": 183,
	"./assignments/materials/wood-hardness.svg": 58,
	"./assignments/materials/wood-longevity.svg": 184,
	"./assignments/materials/zink-plate.svg": 185,
	"./assignments/mineraluld.svg": 186,
	"./assignments/passer.svg": 187,
	"./assignments/pentagon.svg": 188,
	"./assignments/polygon.svg": 189,
	"./assignments/price-diagram-2.svg": 190,
	"./assignments/price-diagram.svg": 191,
	"./assignments/price-sum.svg": 192,
	"./assignments/pricelist/floor-price.svg": 193,
	"./assignments/pricelist/pricelist-1.svg": 194,
	"./assignments/pricelist/pricelist-2.svg": 195,
	"./assignments/pricelist/pricelist-3.svg": 196,
	"./assignments/pricelist/pricelist-4.svg": 197,
	"./assignments/pricelist/pricelist-5.svg": 198,
	"./assignments/pricelist/pricelist-6.svg": 199,
	"./assignments/rektangel.svg": 200,
	"./assignments/retvinkel-trekant.svg": 201,
	"./assignments/round-1-multiple-beregning.svg": 57,
	"./assignments/screws.svg": 202,
	"./assignments/set-a-1/concrete-construction.svg": 203,
	"./assignments/set-a-1/figure-area-2.svg": 204,
	"./assignments/set-a-1/figure-area-3.svg": 205,
	"./assignments/set-a-1/figure-area.svg": 206,
	"./assignments/set-a-1/figure-triangle-2.svg": 207,
	"./assignments/set-a-1/figure-triangle-3.svg": 208,
	"./assignments/set-a-1/figure-triangle-4.svg": 209,
	"./assignments/set-a-1/figure-triangle.svg": 210,
	"./assignments/set-a-1/fractions/five-sixth.svg": 211,
	"./assignments/set-a-1/fractions/half.svg": 212,
	"./assignments/set-a-1/fractions/quater.svg": 213,
	"./assignments/set-a-1/fractions/three-fifth.svg": 214,
	"./assignments/set-a-1/fractions/two-sixths.svg": 215,
	"./assignments/set-a-1/fractions/two-thirds.svg": 216,
	"./assignments/set-a-1/girls-diagram.svg": 217,
	"./assignments/set-a-1/materials/angle-bracket.svg": 218,
	"./assignments/set-a-1/materials/boards.svg": 219,
	"./assignments/set-a-1/materials/hinges.svg": 220,
	"./assignments/set-a-1/materials/insulation.svg": 221,
	"./assignments/set-a-1/materials/nails.svg": 222,
	"./assignments/set-a-1/materials/plywood-sheets.svg": 223,
	"./assignments/set-a-1/materials/posts.svg": 224,
	"./assignments/set-a-1/materials/roof-tiles.svg": 225,
	"./assignments/set-a-1/materials/screws.svg": 226,
	"./assignments/set-a-1/multiple-choice/toolbox/option-1.svg": 227,
	"./assignments/set-a-1/multiple-choice/toolbox/option-2.svg": 228,
	"./assignments/set-a-1/multiple-choice/toolbox/option-3.svg": 229,
	"./assignments/set-a-1/multiple-choice/toolbox/option-4.svg": 230,
	"./assignments/set-a-1/multiple-choice/toolbox/option-5.svg": 231,
	"./assignments/set-a-1/multiple-choice/toolbox/option-6.svg": 232,
	"./assignments/set-a-1/multiple-choice/toolbox/option-7.svg": 233,
	"./assignments/set-a-1/tools/bench-angle.svg": 234,
	"./assignments/set-a-1/tools/fox-tail.svg": 235,
	"./assignments/set-a-1/tools/hammer.svg": 236,
	"./assignments/set-a-1/tools/jigsaw.svg": 237,
	"./assignments/set-a-1/tools/pencil.svg": 238,
	"./assignments/set-a-1/tools/pliers.svg": 239,
	"./assignments/set-a-1/tools/ruler.svg": 240,
	"./assignments/set-a-1/tools/screw-machine.svg": 241,
	"./assignments/set-a-1/tools/water-level.svg": 242,
	"./assignments/set-a-1/wooden-construction.svg": 243,
	"./assignments/shopping-list-2.svg": 244,
	"./assignments/shopping-list-3.svg": 245,
	"./assignments/shopping-list.svg": 246,
	"./assignments/skateboardrampe.svg": 247,
	"./assignments/statistics.svg": 248,
	"./assignments/tabel-tegningshoved.pdf": 59,
	"./assignments/tag.svg": 249,
	"./assignments/tagsten.svg": 250,
	"./assignments/tegl.svg": 251,
	"./assignments/tilbygning.svg": 252,
	"./assignments/tools/allen-key.svg": 253,
	"./assignments/tools/battery-circular-saw.svg": 254,
	"./assignments/tools/bite-forceps.svg": 255,
	"./assignments/tools/chisel.svg": 256,
	"./assignments/tools/dull-hammer.svg": 257,
	"./assignments/tools/eccentric-grinder.svg": 258,
	"./assignments/tools/impact-drill.svg": 259,
	"./assignments/tools/jigsaw.svg": 260,
	"./assignments/tools/laser-meter.svg": 261,
	"./assignments/tools/line-laser.svg": 262,
	"./assignments/tools/list-scissors.svg": 263,
	"./assignments/tools/miter-saw.svg": 264,
	"./assignments/tools/pipe-pliers.svg": 265,
	"./assignments/tools/ruler.svg": 266,
	"./assignments/tools/screw-machine.svg": 267,
	"./assignments/tools/socket-wrench.svg": 268,
	"./assignments/tools/table-circular-saw.svg": 269,
	"./assignments/tools/vernier-calliper.svg": 270,
	"./assignments/traeterrasse.svg": 271,
	"./assignments/trapez.svg": 272,
	"./assignments/trappe.svg": 273,
	"./assignments/trash/bloed-plast.svg": 274,
	"./assignments/trash/deponi.svg": 275,
	"./assignments/trash/gips.svg": 276,
	"./assignments/trash/haard-plast.svg": 277,
	"./assignments/trash/metal.svg": 278,
	"./assignments/trash/option-bloed-plast.svg": 279,
	"./assignments/trash/option-deponi.svg": 280,
	"./assignments/trash/option-gips.svg": 281,
	"./assignments/trash/option-haard-plast.svg": 282,
	"./assignments/trash/option-indendoors-trae.svg": 283,
	"./assignments/trash/option-metal.svg": 284,
	"./assignments/trash/ubehandlet-trae.svg": 285,
	"./assignments/trekant.svg": 286,
	"./assignments/typehus.svg": 287,
	"./assignments/tømmer.svg": 288,
	"./assignments/tømrervinkel.svg": 289,
	"./assignments/vatterpas.svg": 290,
	"./assignments/vinduesudskiftning.svg": 291,
	"./assignments/vinkelbeslag.svg": 292,
	"./background-city.svg": 386,
	"./background-overlay.svg": 387,
	"./background-workshop.svg": 388,
	"./background-workshopBackdrop.svg": 389,
	"./cloud.svg": 390,
	"./colon.svg": 391,
	"./icons/cart1.svg": 392,
	"./icons/cart2.svg": 393,
	"./icons/icon-arrow-cross.svg": 394,
	"./icons/icon-checkmark.svg": 395,
	"./icons/icon-checkmark2.svg": 396,
	"./icons/icon-checkmark3.svg": 397,
	"./icons/icon-close.svg": 398,
	"./icons/icon-download.svg": 399,
	"./icons/icon-error.svg": 400,
	"./icons/icon-loading.svg": 401,
	"./icons/icon-logout.svg": 402,
	"./icons/icon-magnefyingglass.svg": 403,
	"./icons/icon-minus.svg": 404,
	"./icons/icon-pause.svg": 405,
	"./icons/icon-play.svg": 406,
	"./icons/icon-plus.svg": 407,
	"./icons/icon-quality-gold.svg": 408,
	"./icons/icon-quality-none.svg": 409,
	"./icons/icon-quality.svg": 410,
	"./icons/icon-startVideo.svg": 411,
	"./icons/icon-sustainability-gold.svg": 412,
	"./icons/icon-sustainability-none.svg": 413,
	"./icons/icon-sustainability.svg": 414,
	"./icons/icon-workenvironment-gold.svg": 415,
	"./icons/icon-workenvironment-none.svg": 416,
	"./icons/icon-workenvironment.svg": 417,
	"./icons/trophy-gold.svg": 418,
	"./icons/van1.svg": 419,
	"./icons/van2.svg": 420,
	"./logos/cphgamelab_Logo.svg": 421,
	"./logos/fogs-fond-logo.svg": 422,
	"./logos/unord_logo.svg": 423,
	"./progress-bar.svg": 424,
	"./shopItems/coworkers/coworker-7.svg": 425,
	"./shopItems/coworkers/coworker-8.svg": 426,
	"./shopItems/coworkers/coworker-9.svg": 427,
	"./shopItems/educations/education-10.svg": 428,
	"./shopItems/educations/education-11.svg": 429,
	"./shopItems/educations/education-12.svg": 430,
	"./shopItems/educations/education-13.svg": 431,
	"./shopItems/machines/machine-0.svg": 432,
	"./shopItems/machines/machine-1.svg": 433,
	"./shopItems/machines/machine-2.svg": 434,
	"./shopItems/machines/machine-3.svg": 435,
	"./shopItems/machines/machine-4.svg": 436,
	"./shopItems/machines/machine-5.svg": 437,
	"./shopItems/machines/machine-6.svg": 438,
	"./teacher-guide/downloadable-material.svg": 439,
	"./woodlabLogo.svg": 440,
	"./woodlabTitle.svg": 441
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 385;